import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.READ_ALL_ABOUT_IT;

// screens
export const SCREENS = {
  LOADING: 'LOADING',
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  ONBOARDING: 'ONBOARDING',
};

// Redux actions
export const REDUX_ACTIONS = {
  // game details actions
  UPDATE_PRACTICE_DETAILS: 'UPDATE_PRACTICE_DETAILS',
  UPDATE_ONBOARDING_DETAILS: 'UPDATE_ONBOARDING_DETAILS',
  // screen actions
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  // curriculum actions
  INIT_CURRICULUM: 'INIT_CURRICULUM',
  // round actions
  INIT_ROUND: 'INIT_ROUND',
  INCREMENT_CORRECT_ANSWER_COUNT: 'INCREMENT_CORRECT_ANSWER_COUNT',
  PUBLISH_STORY: 'PUBLISH_STORY',
  SET_LAST_PLAYED_STORY: 'SET_LAST_PLAYED_STORY',
  COMPLETE_CURRENT_SET_ID: 'COMPLETE_CURRENT_SET_ID',
  // question actions
  SET_QUESTION: 'SET_QUESTION',
  SERVE_ANSWER: 'SERVE_ANSWER',
  // onboarding round actions
  INIT_ONBOARDING_ROUND: 'INIT_ONBOARDING_ROUND',
  // dev actions
  DEV_TOGGLE_ONBOARDING: 'DEV_TOGGLE_ONBOARDING',
  QUICK_ROUND: 'QUICK_ROUND',
};

export const ONBOARDING_LEVEL_ID = -1;
export const LEVEL_MASTERY_THRESHOLD = 0.83;

// answer types
export const ANSWER_TYPES = {
  AGREE: 'yes',
  DISAGREE: 'no',
};
export const ANSWER_TYPES_ARR = Object.values(ANSWER_TYPES);
